import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function useLoadedLanguages() {
  const { i18n } = useTranslation();
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    if (!i18n) {
      console.error(
        'i18n instance not set. Call init() before using any components',
      );
      setLanguages(() => [{ tag: 'de' }]);
      return;
    }

    if (i18n.fetchingLanguages) {
      i18n.fetchingLanguages.then((languages) => {
        for (const [tag, lang] of Object.entries(languages)) {
          lang.tag = tag;
        }

        setLanguages(languages);
      });
    }
  }, [i18n]);

  return languages;
}
